import { render } from "./Navbar.vue?vue&type=template&id=2e89b294&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=ts"
export * from "./Navbar.vue?vue&type=script&lang=ts"

import "./Navbar.vue?vue&type=style&index=0&id=2e89b294&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2e89b294"

export default script